import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { BorderGrid, CheckBoxGrid } from './Pdf2284Styled';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FormCheckboxPdf from '../../../../common/Forms/FormCheckboxPdf';
import {
  GridLeft,
  GridSection,
  DialogHeader,
  DialogHeading,
} from '../../../Episode.Styled';

export const CheckboxGridItems = ({ xs, data, text }) => {
  return (
    <BorderGrid item xs={xs}>
      {text}
      <CheckBoxGrid>
        {data?.map((item, index) => (
          <FormCheckboxPdf key={index} item={item} />
        ))}
      </CheckBoxGrid>
    </BorderGrid>
  );
};

export const DiscriptionGrid = ({ title1, title2, description }) => {
  const getTitleDiscription = [
    { detail: title1 },
    { detail: title2 },
    { detail: description },
  ];

  return (
    <GridSection mx={2} container spacing={1}>
      <GridLeft container item xs={12}>
        {getTitleDiscription.map((item) => (
          <Typography>{item.detail}</Typography>
        ))}
      </GridLeft>
    </GridSection>
  );
};

export const HeaderGrid = ({
  leftTitle1,
  leftTitle2,
  leftTitle3,
  rightTitle1,
  rightTitle2,
  rightTitle3,
}) => {
  const renderTitles = (titles) => {
    return titles.map((title, index) => (
      <Typography key={index}>{title}</Typography>
    ));
  };
  return (
    <>
      <Grid item xs={4}>
        {renderTitles([leftTitle1, leftTitle2, leftTitle3])}
      </Grid>
      <Grid item xs={8} style={{ textAlign: 'end' }}>
        {renderTitles([rightTitle1, rightTitle2, rightTitle3])}
      </Grid>
    </>
  );
};

export const DetailGrid = ({ xs, title, value }) => {
  return (
    <BorderGrid item xs={xs}>
      {title}
      {Array.isArray(value) ? (
        value.map((item, index) => <Typography key={index}>{item}</Typography>)
      ) : (
        <Typography>{value}</Typography>
      )}
    </BorderGrid>
  );
};

export const PrintButtonHeader = ({ handlePrint, handleClose }) => {
  return (
    <DialogHeader>
      <DialogHeading variant="h5"></DialogHeading>
      <Box>
        <Button variant="contained" onClick={() => handlePrint()}>
          Print
        </Button>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogHeader>
  );
};

export const reportingDetailsGrid = (data) => {
  return (
    <GridLeft container item xs={12}>
      {data.map((item) => (
        <Grid item xs={item.width}>
          {item.title}
          <Typography>{item.detail}</Typography>
        </Grid>
      ))}
      <Box my={4}></Box>
    </GridLeft>
  );
};

export const DistributionGrid = ({ title1, title2 }) => {
  return (
    <GridLeft container item xs={12}>
      <Grid item xs={2}>
        {title1}
      </Grid>

      <Grid item xs={10}>
        {title2}
      </Grid>
      <Box my={4}></Box>
    </GridLeft>
  );
};

export const mappedData = (data) => {
  return data.map((item) => (
    <DetailGrid xs={item.xs} title={item.title} value={item.value} />
  ));
};

export const mappedCheckBox = (data) => {
  return data.map((item) => (
    <CheckboxGridItems xs={item.xs} data={item.data} text={item.title} />
  ));
};
